module.exports = __webpack_public_path__ + "static/media/sweets.1d986e56.jpeg";